import React from "react";
import KinsaHeaderImage from "public/kinsa-header.svg";
import KinsaHeaderWhiteImage from "public/kinsa-header-white.svg";
import Image from "next/image";

interface KinsaHeaderProps {
  size?: "sm" | "lg";
  variant?: "default" | "white";
}

const SmallKinsaHeader: React.FC = () => (
  <Image src={KinsaHeaderImage} alt="kinsa logo" height={32} unoptimized />
);

const LargeKinsaHeader: React.FC<{ variant?: "default" | "white" }> = ({
  variant = "default",
}) => (
  <Image
    src={variant === "white" ? KinsaHeaderWhiteImage : KinsaHeaderImage}
    alt="kinsa logo"
    unoptimized
  />
);

const KinsaHeader: React.FC<KinsaHeaderProps> = ({
  size = "lg",
  variant = "default",
}) =>
  size === "lg" ? <LargeKinsaHeader variant={variant} /> : <SmallKinsaHeader />;

export default KinsaHeader;
